import { Button, PresetThemes } from '@travelnest/merlin.button';
import { Input } from '@travelnest/merlin.input';
import { Rule } from '@travelnest/merlin.rule';
import * as React from 'react';
import { PasswordResetError } from '../../../../errors/passwordResetError';
import { Form, FormError, FormLabel, FormRow } from '../../../components/form';
import { Content } from '../../../components/page';
import { SetPassword } from '../../../components/set-password/SetPassword';
import { resetConfirmPasswordMessage } from './helpers';

interface IResetNewState {
	email: string;
	password: string;
	code: string;
	isValid: boolean;
}

interface IResetNewProps {
	loading: boolean;
	resetEmail: string;
	error: PasswordResetError;
	onSubmit: (email: string, password: string, code: string) => any;
}

export class ResetVerifyPasswordComponent extends React.Component<
	IResetNewProps,
	IResetNewState
> {
	public componentWillMount() {
		this.setState({
			email: this.props.resetEmail || '',
			password: '',
			isValid: true,
		});
	}
	public componentDidMount() {
		this.setState({ password: '', isValid: false });
		document.title = 'Reset Password | Travelnest';
	}

	public onPasswordChange(password: string, isValid: boolean) {
		this.setState({ password, isValid });
	}

	public render() {
		const code = ((value: string) => this.setState({ code: value })).bind(
			this
		);
		const submit = () =>
			this.props.onSubmit(
				this.state.email,
				this.state.code,
				this.state.password
			);

		return (
			<>
				<Content>
					<h1 className="login__title-text">Reset Password</h1>
					<Rule />
					<Form
						onSubmit={(e) => e.preventDefault()}
						data-matomo-form
						data-matomo-name="customerpasswordverify"
						name="customerpasswordverify"
					>
						{!this.props.resetEmail && (
							<>
								<p>Please re-enter your email address.</p>
								<FormRow>
									<FormLabel htmlFor="email">
										Email address
									</FormLabel>
									<Input
										className="reset__code-input"
										data-matomo-mask
										required
										aria-label="Email address"
										onChange={(e) =>
											this.setState({
												email: e.target.value,
											})
										}
										name="code"
										id="email"
										type="email"
									/>
								</FormRow>
							</>
						)}
						<p>
							We have sent you a 6 digit code to your email
							address or mobile number.
							<br />
							Please enter this code below with a new password.
						</p>
						<FormRow>
							<FormLabel htmlFor="code">
								Verification number
							</FormLabel>
							<Input
								className="reset__code-input"
								data-matomo-mask
								required
								aria-label="Verification number"
								onChange={(e) => code(e.target.value.trim())}
								name="code"
								id="code"
								type="number"
							/>
						</FormRow>

						<SetPassword
							onPasswordChange={this.onPasswordChange.bind(this)}
							isReset={true}
						></SetPassword>
						{this.props.error && this.props.error.code && (
							<FormError>
								{resetConfirmPasswordMessage(
									this.props.error.code,
									this.props.error.message
								)}
							</FormError>
						)}
						<p>
							<Button
								buttonType={PresetThemes.Primary}
								disabled={
									!this.state.isValid && this.props.loading
								}
								loading={this.props.loading}
								onClick={() => submit()}
							>
								Reset password
							</Button>
						</p>
					</Form>
				</Content>
			</>
		);
	}
}
